export const DASHBOARD_CONFIG = {
  courseId: '6a19a79d7332afaaedf692de',
} as const;
